import React from 'react'

const BadgeSmall = (props) => {
  return (
    <button class={`rounded-full ${props.language ? 'ring-2' : 'ring-1'} text-xs ring-black px-3 py-1 tracking-wide text-gray-600 font-bold hover:bg-yellow-200`}>
      {props.name}
    </button>
  )
}

export default BadgeSmall
